<template>
  <section id="page-news">
    <div class="container">
      <div class="row">

        <clearfix :biggest="true"></clearfix>

        <div class="col-sm-12 content fb-bg-dark">
          <h3>{{ $t('message.title.main.news') }}</h3>
        </div>
      </div>

      <div class="row" v-show="news.length === 0">
        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          {{ $t('message.text.no_foobars') }}
        </div>
      </div>

      <div class="row" v-show="news.length > 0" v-for="fb in news">

        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          <h4>
            <router-link :to="{name: 'Foobar', params: {id: fb.id}}">{{ fb.title }}</router-link>
          </h4>

          <div class="foobar-description" v-html="fb.description"></div>
        </div>
      </div>

      <clearfix :biggest="true"></clearfix>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Clearfix from '@/components/utils/Clearfix'
  import config from './Config'

  Vue.use(VueAxios, axios)

  export default {
    data() {
      return {
        news: []
      }
    },
    components: {
      Clearfix
    },
    created() {
      Vue.axios.get(config.urls.foobar_news)
        .then((response) => {
          this.news = response.data
        })
    }
  }
</script>

<style>
  #page-news {
    background: url('../../assets/img/bg/coding.jpg') center fixed no-repeat;
    background-size: cover;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// FoobarNews.vue?1cf95110